import Button, { buttonClasses } from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { Title, Loader } from 'components';

import { makeStyles } from '@material-ui/core';

import styled from 'shared/utils/styled';

const BUTTONS_HOVER_OPACITY = 0.7;

export const ButtonLoader = () => (
  <Loader size={15} style={{ marginLeft: 10, color: 'inherit' }} />
);

const CommonButton = styled(Button)(({ theme }) => ({
  minWidth: 'auto',
  padding: '6px 12px',
  fontSize: 14,
  fontFamily: 'NeoSansStd',
  fontWeight: 400,
  borderRadius: 29,
  color: '#fff',
  textTransform: 'uppercase',
  transition: 'all .15s',
  [`&.${buttonClasses.disabled}`]: {
    background: '#f5f5f5',
    color: '#c8c8c8',
  },
  [theme.breakpoints.down('sm')]: {
    padding: 6,
    fontSize: 13,
  },
}));

export const SaveButton = styled(CommonButton)(() => ({
  background: '#218D7A',
  '&:hover': {
    background: '#218D7A',
    opacity: BUTTONS_HOVER_OPACITY,
  },
}));

export const CloseButton = styled(CommonButton)(() => ({
  background: '#7E8483',
  '&:hover': {
    background: '#7E8483',
    opacity: BUTTONS_HOVER_OPACITY,
  },
}));

export const ReopenButton = styled(CommonButton)(() => ({
  background: '#828282',
  '&:hover': {
    background: '#828282',
    opacity: BUTTONS_HOVER_OPACITY,
  },
}));

export const CompleteButton = styled(CommonButton)(() => ({
  background: 'green',
  '&:hover': {
    background: 'green',
    opacity: BUTTONS_HOVER_OPACITY,
  },
}));

export const CancelButton = styled(CommonButton)(() => ({
  background: '#A51010',
  '&:hover': {
    background: '#A51010',
    opacity: BUTTONS_HOVER_OPACITY,
  },
}));

export const StyledTitle = styled(Title)(() => ({
  margin: 0,
  fontSize: 21,
}));

export const StyledIconButton = styled(IconButton)(() => ({
  padding: 2,
  background: 'transparent',
}));

export const useStyles = makeStyles((theme) => ({
  btnControlWrapper: {
    padding: '5px 10px',
    paddingLeft: 0,
  },
  textArea: {
    minHeight: 185,
    padding: 9,
    border: '1px solid rgba(34, 64, 96, .2)',
  },
  rootSelect: {
    width: '100%',
  },
  select: {
    width: '100%',
    justifyContent: 'space-between',
    paddingLeft: 9,
    paddingRight: 9,
    paddingBottom: 5,
    borderBottom: '1px solid rgba(34, 64, 96, .2)',
  },
  selectBtn: {
    background: '#F0F3F7',
  },
  paper: {
    borderRadius: 0,
    boxShadow: 'none',
    background: '#F4F4F4',
  },
  flex: {
    display: 'flex',
  },
  spaceBetween: {
    justifyContent: 'space-between',
  },
  text: {
    fontSize: 15,
  },
  datePickerRoot: {
    borderBottom: '1px solid rgba(34, 64, 96, .2)',
  },
  button: {
    minWidth: 'auto',
    padding: '6px 12px',
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    fontWeight: 400,
    borderRadius: 29,
    color: '#fff',
    textTransform: 'uppercase',
    '&.Mui-disabled': {
      color: 'rgba(255, 255, 255, .7)',
    },
  },
  buttonsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    marginTop: 10,
  },
  buttonsWrapperFlexStart: {
    justifyContent: 'flex-start',
  },
  buttonsBox: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
}));
